import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './index.css'
import checkboxIcon from '../../images/checkboxOrange.png'

export default class CheckboxField extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func,
    error: PropTypes.string
  }

  handleChange = (e) => {
    const { onChange } = this.props
    onChange && onChange(e.target.checked)
  }

  render() {
    const { label, labelUrl, checked, error, id } = this.props

    return (
      <div className="form-group">
        <div>
          <input id={id} type="checkbox" checked={checked} onChange={this.handleChange} className="css-checkbox" />
          <label
            className="css-label"
            htmlFor={id}
            style={{backgroundImage: `url(${checkboxIcon})`}}
            >
            { labelUrl && <a href="/terms" target="_blank">{ label }</a> }
            { !labelUrl && label }
          </label>
        </div>
        { error && <div className="error">{ error}</div> }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CheckboxField/index.js